import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import {
  Alert,
  Button,
  CircularProgress,
  Container,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextareaAutosize,
  TextField,
  Typography,
} from "@mui/material";
import { Box, width } from "@mui/system";
import React, { useEffect, useMemo, useState } from "react";
import PhoneInputWithCountrySelect from "react-phone-number-input";
import { Link, useNavigate, useParams } from "react-router-dom";
import countryList from "react-select-country-list";
import { useDispatch, useSelector } from "react-redux";
import { sgibaseurl, sgiurl, sgiurlv1, url } from "../../baseUrl";
import axios from "axios";
import { lightBackground, white } from "../../Assets/Theme/ThemeColors";
import { userUnAuthorized } from "../../redux/actions/commonAction";
import CustomizedSnackbars from "../../Components/SnackBar/SnackBar";

const BrandPage = () => {
  let { id } = useParams();

  const [brandDetails, setBrandDetails] = useState({
    accountCode: "",
    brandCode: "0000",
    branchCode: "",
    contactNumber: "",
    isActive: true,
    name: "",
    shortName: "",
    websiteUrl: "",
    email: "",
  });
  const [allBranch, setAllBranch] = useState([]);
  const [allAccounts, setAllAccounts] = useState([]);

  const [isDisable, setIsDisable] = useState(false);
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");

  let param = id.split("_");
  let brandId = param[0];
  let accessType = param[param.length - 1];
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const state = useSelector((state) => state.user.data);

  useEffect(() => {
    if (accessType !== "CREATE") {
      getBrand();
    }
    // getAllAccounts();
    getAllBranches();
  }, []);

  const getAllAccounts = async () => {
    await axios
      .get(`${sgiurlv1}/stripe/getAllAccounts`, {
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      })
      .then(async (response) => {
        let data = response.data.data;
        setAllAccounts(data);
        console.log("setAllAccounts", data);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          console.log("unauthorized error");
          userUnAuthorized(dispatch);
        } else {
          console.log("network error");
          setIsLoaded(false);
          setIsOpen(true);
          setMessage(error.message);
          setSeverity("error");
        }
      });
  };
  const getAllBranches = async () => {
    await axios
      .get(`${url}/branch`, {
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      })
      .then(async (response) => {
        let data = response.data.data;
        setAllBranch(data);
        console.log("branch", data);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          console.log("unauthorized error");
          userUnAuthorized(dispatch);
        } else {
          console.log("network error");
          setIsLoaded(false);
          setIsOpen(true);
          setMessage(error.message);
          setSeverity("error");
        }
      });
  };

  const getBrand = async () => {
    const response = await axios
      .post(
        `${sgiurl}/brands/getSpecific`,
        { _id: brandId },
        {
          headers: {
            Authorization: `Bearer ${state.token}`,
          },
        }
      )
      .then((response) => {
        let data = response.data.data;
        console.log("brand", data);
        setIsDisable(true);

        setBrandDetails(data);
        //reaOnly and update

        if (accessType === "readOnly") {
          setIsReadOnly(true);
        } else {
          setIsReadOnly(false);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          console.log("unauthorized error");
          userUnAuthorized(dispatch);
        } else {
          console.log("network error");
          setIsLoaded(false);
        }
      });
  };

  const formSubmit = async () => {
    setIsLoaded(true);
    var data =
      accessType === "CREATE"
        ? {
            ...brandDetails,
          }
        : {
            ...brandDetails,
            _id: brandId,
          };
    await axios
      .post(
        `${sgiurl}${
          accessType === "CREATE" ? "/brands/addNew" : "/brands/edit"
        }`,
        data,
        {
          headers: {
            Authorization: `Bearer ${state.token}`,
          },
        }
      )
      .then(function (response) {
        console.log(response);
        setIsReadOnly(true);

        //snackbar
        setTimeout(() => {
          navigate("/brand/list");
        }, 2000);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          console.log("unauthorized error");
          // userUnAuthorized(dispatch);
        } else {
          console.log("network error");
          setIsLoaded(false);
        }
      });

    setIsLoaded(false);
  };

  return (
    <>
      <Container
        style={{
          maxWidth: "100%",
          padding: "0px",
          overflowY: "scroll",
          height: "90vh",
        }}
      >
        <Box sx={{ mt: 3 }}>
          <Paper sx={{ p: 3, mr: 2, ml: 2 }}>
            <Grid container sx={{ mt: 2 }}>
              <Typography variant="h5" color="Primary">
                {accessType === "CREATE" ? "Add New Brand" : "Brand"}
              </Typography>
            </Grid>
            <Grid container className="Row">
              <Grid item container md={3} xs={12} sx={{ p: 1 }}>
                <TextField
                  name="name"
                  label="Brand Code"
                  type="text"
                  margin="normal"
                  fullWidth
                  value={brandDetails.brandCode}
                  disabled={true}
                  onChange={(e) =>
                    setBrandDetails({
                      ...brandDetails,
                      brancdCode: e.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item container md={3} xs={12} sx={{ p: 1 }}>
                <TextField
                  name="name"
                  label="Brand Name"
                  type="text"
                  margin="normal"
                  fullWidth
                  value={brandDetails.name}
                  disabled={isReadOnly}
                  onChange={(e) =>
                    setBrandDetails({ ...brandDetails, name: e.target.value })
                  }
                />
              </Grid>
              <Grid item container md={3} xs={12} sx={{ p: 1 }}>
                <TextField
                  name="name"
                  label="Brand Short Name"
                  type="text"
                  margin="normal"
                  fullWidth
                  value={brandDetails.shortName}
                  disabled={isReadOnly}
                  onChange={(e) =>
                    setBrandDetails({
                      ...brandDetails,
                      shortName: e.target.value,
                    })
                  }
                />
              </Grid>
            </Grid>

            <Grid container className="Row">
              <Grid item container md={3} xs={12} sx={{ p: 1 }}>
                <TextField
                  name="number"
                  label="Contact Number"
                  type="text"
                  margin="normal"
                  fullWidth
                  value={brandDetails.contactNumber}
                  disabled={isReadOnly}
                  onChange={(e) =>
                    setBrandDetails({
                      ...brandDetails,
                      contactNumber: e.target.value,
                    })
                  }
                />
              </Grid>

              <Grid item container md={3} xs={12} sx={{ p: 1 }}>
                <TextField
                  name="name"
                  label="Brand Email"
                  type="text"
                  margin="normal"
                  fullWidth
                  value={brandDetails.email}
                  disabled={isReadOnly}
                  onChange={(e) =>
                    setBrandDetails({ ...brandDetails, email: e.target.value })
                  }
                />
              </Grid>
              <Grid item container md={3} xs={12} sx={{ p: 1 }}>
                <TextField
                  name="name"
                  label="Brand Website"
                  type="text"
                  margin="normal"
                  fullWidth
                  value={brandDetails.websiteUrl}
                  disabled={isReadOnly}
                  onChange={(e) =>
                    setBrandDetails({
                      ...brandDetails,
                      websiteUrl: e.target.value,
                    })
                  }
                />
              </Grid>
            </Grid>
            <Grid container className="Row">
              {/* <Grid
                item
                container
                md={4}
                xs={12}
                sx={{ pt: 3, pl: 1, pr: 1, pb: 1 }}
              >
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Select Stripe Account
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label2"
                    id="demo-simple-select2"
                    value={brandDetails.accountCode}
                    label="Select Stripe Account"
                    style={{
                      textAlign: "left",
                    }}
                    onChange={(e) => {
                      setBrandDetails({
                        ...brandDetails,
                        accountCode: e.target.value,
                      });
                    }}
                    disabled={isReadOnly}
                  >
                    {allAccounts?.length > 0 ? (
                      allAccounts?.map((item) => {
                        return (
                          <MenuItem value={item.account}>
                            {item.account}
                          </MenuItem>
                        );
                      })
                    ) : (
                      <MenuItem value={""}>None</MenuItem>
                    )}
                  </Select>
                </FormControl>
              </Grid> */}
              <Grid
                item
                container
                md={3}
                xs={12}
                sx={{ pt: 3, pl: 1, pr: 1, pb: 1 }}
              >
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Select Branch
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={brandDetails.branchCode}
                    label="Select Branch"
                    style={{
                      textAlign: "left",
                    }}
                    onChange={(e) => {
                      setBrandDetails({
                        ...brandDetails,
                        branchCode: e.target.value,
                      });
                    }}
                    disabled={isReadOnly}
                  >
                    {allBranch?.length > 0 ? (
                      allBranch?.map((item) => {
                        return (
                          <MenuItem value={item.branchCode}>
                            {item.branchName}
                          </MenuItem>
                        );
                      })
                    ) : (
                      <MenuItem value={""}>None</MenuItem>
                    )}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item container md={3} xs={12} sx={{pl:1, pt: 3 , pr:1 }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Brand Status
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={brandDetails.isActive}
                    label="Brand Status"
                    style={{
                      textAlign: "left",
                    }}
                    onChange={(e) => {
                      setBrandDetails({
                        ...brandDetails,
                        isActive: e.target.value,
                      });
                    }}
                    disabled={isReadOnly}
                  >
                    <MenuItem value={true}>Active</MenuItem>
                    <MenuItem value={false}>In-active</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            <Grid
              container
              className="Row"
              sx={{ mt: 2 }}
              style={{
                gap: "10px",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Grid item container md={1} xs={1}>
                <Button
                  type="clear"
                  style={{
                    border: `1px solid ${lightBackground}`,
                    color: `${lightBackground}`,
                    background: `${white}`,
                  }}
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  onClick={() => {
                    navigate("/brand/list");
                  }}
                >
                  back
                </Button>
              </Grid>
              {accessType !== "readOnly" && !isReadOnly ? (
                <Grid item container md={1} xs={1}>
                  <Button
                    onClick={formSubmit}
                    variant="contained"
                    style={{
                      background: `${lightBackground}`,
                      color: `${white}`,
                    }}
                    margin="normal"
                    fullWidth
                    disabled={isLoaded}
                  >
                    {isLoaded ? (
                      <span>
                        {" "}
                        <CircularProgress
                          style={{
                            color: `${white}`,
                            height: "20px",
                            width: "20px",
                          }}
                        />
                      </span>
                    ) : accessType === "CREATE" ? (
                      "save"
                    ) : (
                      "UPDATE"
                    )}
                  </Button>
                </Grid>
              ) : (
                []
              )}
            </Grid>
          </Paper>
        </Box>
      </Container>
      <CustomizedSnackbars
        isOpen={isOpen}
        severity={severity}
        message={message}
      />
    </>
  );
};

export default BrandPage;
